import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseService } from '../../_shared/services/base.service';
import { JobPostcodeDto, JobPostcodeListDto } from '../models/jobPostcode';

@Injectable({
  providedIn: 'root',
})
export class JobPostcodeService extends BaseService<JobPostcodeDto, JobPostcodeListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject('BASE_URL') protected override baseUrl: string
  ) {
    super(http, baseUrl, 'jobpostcode');
  }
}
